import type { RequiredOAISchema } from '~/types/openapi';

/**
 * 유저 개인정보 제거 함수
 *
 * MarketBuyerResponse에서 개인정보(전화번호·이름·주소)를 제외한 나머지 정보를 반환한다.
 */
export const removePersonalData = (
  user: RequiredOAISchema<'MarketBuyerResponse'> | undefined,
) => {
  if (user === undefined) return undefined;

  const { phoneNumber, name, addresses, ...userInfo } = user;

  return userInfo;
};
